<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      hidden
      :schema="schema"
      name="entered_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        flat
        clearable
        v-model="item.entered_by"
        :items="optionUserItems"
        text-field="username"
        value-field="id"
        :validator="$v.item[schema.fields.entered_by.name]"
        :loading="optionUserWorking"
        name="entered_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.entered_by"
        :form-state="formState"
        readonly
      ></o-select>
    </o-widget-wrapper>
    <b-container fluid="xs" class="my-2">
      <b-row>
        <b-col
          cols="2"
          class="text-right pr-0 d-flex justify-content-end align-items-center"
        >
          <p>Upload (atleast 2 photos)*</p>
        </b-col>
        <b-col
          cols="9"
          class="p-3 ml-2 d-flex flex-row justify-content-between align-items-center"
        >
          <b-container fluid="xs" class="my-2 d-flex">
            <template v-for="(image, index) in getPhotos">
              <div class="position-relative w-auto h-auto">
                <button
                  @click="showConfirmDelete(image)"
                  type="button"
                  class="close position-absolute top-0 end-0"
                  style="right: 5px; z-index: 100; top: -10px"
                  aria-label="Close"
                >
                  <span style="font-size: 30px; color: red" aria-hidden="true"
                    >&times;</span
                  >
                </button>
                <b-avatar
                  :key="index"
                  class="avatar mr-2"
                  size="5rem"
                  :src="image.details.file"
                />
              </div>
            </template>
            <button @click="$refs.uploadImage.click()">
              <b-avatar
                variant="info"
                size="4rem"
                @click="$refs.file.click()"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Plus_symbol.svg/500px-Plus_symbol.svg.png"
              >
              </b-avatar>
            </button>
            <input
              type="file"
              @change="onFileChange"
              style="display: none"
              ref="uploadImage"
            />
          </b-container>
        </b-col>
      </b-row>
    </b-container>
    <o-widget-wrapper
      :schema="schema"
      name="job"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <job-search
        v-model="item.job"
        :form-state="formState"
        name="job"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.job"
        @update-job="updateJob"
        :create="create"
        :address="item.site_address"
        :suburb="item.suburb"
        :job_number="item.job_number"
      ></job-search>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="builder"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        :value="item.builder__name || item.job__customer__name"
        :items="optionCustomerItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionCustomerWorking"
        name="builder__name"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.builder__name"
        readonly
      >
      </o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="description"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-area
        v-model="item.description"
        :form-state="formState"
        name="description"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.description"
      ></o-text-area>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="site_address"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.site_address"
        :form-state="formState"
        name="site_address"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.site_address"
        readonly
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="suburb"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.suburb"
        :form-state="formState"
        name="suburb"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.suburb"
        readonly
      ></o-text-field>
    </o-widget-wrapper>

    <!-- :validators="$v.item" -->
    <o-widget-wrapper
      :schema="schema"
      name="category_of_works"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="getCategoryOfWorks"
        :items="optionCodeCategoryOfWorkItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeCategoryOfWorkWorking"
        name="category_of_works"
        :server-errors="_se"
        v-bind="schema.fields.category_of_works"
        store-name="CategoryOfWorks"
        @input="changeCategoryOfWorks"
      ></o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      v-if="item.category_of_works.length > 0"
      :schema="schema"
      name="quoted_amount"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        prepend="$"
        default-class="w-50"
        col-size="6"
        v-model="item.quoted_amount"
        :form-state="formState"
        name="quoted_amount"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.quoted_amount"
        @input="checkIfValid()"
      ></o-money-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="supervisor"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.supervisor"
        :items="getFilteredSupervisor"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        name="supervisor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supervisor"
        store-name="Supervisor"
      >
      </o-select>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="sub_contractor"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        disabled
        v-model="getSubContructor"
        :items="optionSupplierItems"
        text-field="display_name"
        value-field="id"
        sort-field="display_name"
        :form-state="formState"
        :loading="optionSupplierWorking"
        name="sub_contractor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.sub_contractor"
        store-name="Supplier"
      >
      </o-select>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
  UseRestModuleMixin,
} from "../../../vue-ocom/mixins";
import { HasGroupMixin } from "../../../vue-ocom/auth/mixin/AuthFormMixins.js";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OSpeedSelect from "../../../vue-ocom/components/forms/fields/OSpeedSelect";
import OGroupButton from "../../components/group_button/OGroupButton";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import OFilesTable from "../../../vue-ocom/components/table/common/OFilesTable";
import OMoneyField from "../../components/money_field/OMoneyField";
import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";

import { default as CustomerForm } from "../../customer/components/ItemForm";
import { default as SupervisorForm } from "../../supervisor/components/ItemForm";
import { default as JobForm } from "../../job/components/ItemForm";
import { default as FileUploadFormTable } from "../../file_upload/components/ItemFormTable";
// import { default as FileUploadFormCards } from '../../file_upload/components/ItemFormCards';
import { default as RepairMaterialsUsedFormTable } from "../../repair_materials_used/components/ItemFormTable";
// import { default as RepairMaterialsUsedFormCards } from '../../repair_materials_used/components/ItemFormCards';
//     import { default as NoteFormTable } from '../../note/components/ItemFormTable';
// import { default as NoteFormCards } from '../../note/components/ItemFormCards';
import { default as InvoiceFormTable } from "../../invoice/components/ItemFormTable";
import { default as ServicePurchaseOrderFormCards } from "../../service_purchase_order/components/ItemFormCards";
// import { default as InvoiceFormCards } from '../../invoice/components/ItemFormCards';
import { default as JobSearch } from "../../components/job_search/JobSearch";
import { default as EmployeeForm } from "../../employee/components/ItemForm";
// import OSpeedSelect from '../../../../../asset_register/vue/src/vue-ocom/components/forms/fields/OSpeedSelect.vue';
import { default as CodeCategoryOfWorkForm } from "../../code_category_of_work/components/ItemForm";

import { default as ExtraMaintenanceNoteFormTable } from "../../extra_maintenance_note/components/ItemFormTable";
// import { default as ExtraMaintenanceNoteFormCards } from '../../extra_maintenance_note/components/ItemFormCards';
import OMultiCheckbox from "../../../vue-ocom/components/forms/fields/OMultiCheckbox";

import { default as WorkflowInstanceForm } from "../../../vue-workflow/app/workflow_instance/components/ItemForm";

import _ from "lodash";

import moment from "moment";
import { CalculateTotalRepairs } from "@/app/service_repair/utils.js";
import { uploadFile } from "../../../lib/common/uploadPhotos.js";
import TriggerButton from "@/vue-workflow/components/TriggerButton.vue";
import Swal from "sweetalert2";
import store from "@/app/components/store.js";

export default {
  mixins: [
    HasGroupMixin("Administrator"),
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ServiceExtra"),
    UseRestModuleMixin(["FileUpload"]),
    CreateCodeTableFetchMixin([
      "Customer",
      "User",
      "Supervisor",
      "CodeFileType",
      "Employee",
      "CodeExtraType",
      "Supplier",
      "CodeCategoryOfWork",
    ]),
  ],
  components: {
    TriggerButton,
    WorkflowInstanceForm,
    OMultiCheckbox,
    ServicePurchaseOrderFormCards,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,
    OCheckbox,
    OSelect,
    OSpeedSelect,
    OGroupButton,
    OTextField,
    OTextArea,
    OFilesTable,
    EmployeeForm,
    CustomerForm,
    SupervisorForm,
    JobForm,
    OMoneyField,
    FileUploadFormTable,
    //FileUploadFormCards,
    RepairMaterialsUsedFormTable,
    //RepairMaterialsUsedFormCards,
    //        NoteFormTable,
    //NoteFormCards,
    InvoiceFormTable,
    //InvoiceFormCards,
    JobSearch,
    CodeCategoryOfWorkForm,
    ExtraMaintenanceNoteFormTable,
    // ExtraMaintenanceNoteFormCards,
    ONotesTable,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    create: { type: Boolean, default: false },
  },
  data: () => ({
    images: [],
    url: null,
    total_cost_of_repair_gst: null,
    total_cost_of_repair_inc_gst: null,
    moneySymbol: "$",
    extra_type_maintenance_request: 5,
    showApproveDetails: false,
    buttonValue: [
      { id: true, color: "#000", textField: "Yes" },
      { id: false, color: "#000", textField: "No" },
    ],
    purchase_order: {
      created_date: null,
      modified_date: null,
      po_number: "",
      date_po_supplied: null,
      invoice_number: "",
      date_invoiced: null,
      invoiced_by: null,
      invoiced_by__username: null,
    },
    schemaModel: cleanUpModel(schema.ServiceExtra, {}),
    parentId: 0,
    parentType: "service_extra",
    upload_file_type: 11,
  }),
  methods: {
    checkIfValid() {
      if (this.$v.item.quoted_amount.$invalid) {
        this.formState.dirty = false;
        this.formState.invalid = true;
        return;
      }
      this.formState.dirty = true;
      this.formState.invalid = false;
    },
    changeCategoryOfWorks(data) {
      this.item.category_of_works = [data];

      if (this.item.category_of_works.length > 0) {
        const item = this.optionCodeCategoryOfWorkItems.filter(
          (item) => item.id == this.item.category_of_works[0]
        );
        this.item.quoted_amount = item[0].extra_price;
      }
    },
    showSuccessfullyDeleted(filename) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "File Deleted!",
        text: "We removed the file: " + filename,
      }).then(function () {
        // Noop!
      });
    },
    refresh() {
      var parent = {
        parent_id: this.parentId,
        parent_type: this.parentType,
      };
      store.dispatch("get_files", parent).then((results) => {
        this.files = results.results;
      });
    },
    changed(items) {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", items);
    },
    removeItem(item) {
      var items = _.filter(this.items || [], function (f) {
        if (f !== item) {
          return f;
        }
      });
      const filterPhotos = this.item.repair_files.filter(
        (photo) => photo.id != item.id
      );
      this.item.repair_files = filterPhotos;
      this.changed(items);
    },
    showConfirmDelete(item) {
      const vm = this;
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Are you sure?",
        text: "Remove this file " + item.details.name + "?",

        confirmButtonText: "Yes, delete it!",
        confirmButtonColor: "#ff5349",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        cancelButtonColor: "#999999",
      }).then(function (isConfirm) {
        if (isConfirm["value"]) {
          vm.deleteFileUploadItem(item).then(() => {
            vm.removeItem(item);
            // vm.getAllFileUpload();
            vm.refresh();
          });
          vm.showSuccessfullyDeleted(item.details.name);
        }
      });
    },
    reload(data) {
      this.$emit("reload");
    },
    async onFileChange(e) {
      // console.log('file', file.size)
      // this.url = URL.createObjectURL(file);
      // this.images.push(URL.createObjectURL(file));
      const file = e.target.files[0]; //this is the file
      const data = {
        parentId: this.parentId,
        parentType: this.parentType,
        upload_file_type: this.upload_file_type,
        upload_file: file,
      };
      const items = await uploadFile(data);
      this.item.repair_files.push(items);
      this.$refs["uploadImage"].reset();
    },
    checkCancelledBy() {
      if (this.item.cancelled_by) {
        this.item.cancelled_date = moment().format("YYYY-MM-DD");
      } else {
        this.item.cancelled_date = null;
      }
    },
    // OnBeforeGetEmployeeCodeList(list_options) {
    //   list_options.query = {
    //     and: [
    //       ["item_type", "eq", 1],
    //       ["entity", "eq", 1],
    //     ],
    //   };
    // },
    updateJob(e) {
      this.item.job = e.id;
      this.item.site_address = e.site_address;
      this.item.suburb = e.suburb;

      if (e.customer) {
        this.item.builder = e.customer;
        this.item.builder__name = e.customer__name;
      }
    },

    compute_labour_total_cost() {
      CalculateTotalRepairs(this.item);

      this.total_cost_of_repair_gst = this.item.total_cost_of_repair_gst;
      this.total_cost_of_repair_inc_gst = this.item.total_cost_of_repair_inc_gst;
    },
  },
  computed: {
    checkErrors() {
      return this.$v.item.quoted_amount;
    },
    getCategoryOfWorks: {
      get: function () {
        if (this.item.category_of_works.length > 0) {
          return this.item.category_of_works[0];
        }

        return null;
      },
      set: function (newValue) {
        this.item.category_of_works = [newValue];
      },
    },
    getFilteredSupervisor() {
      return this.optionSupervisorItems.filter(
        (item) => item.customer == this.item.builder
      );
    },
    getPhotos() {
      return this.item.repair_files;
    },
    getSubContructor() {
      return (this.item.sub_contractor = this.currentUser.role.supplier);
    },
    checkCurrentUser() {
      return this.optionUserItems;
    },
    checkApproveSubcontractorPayment() {
      return this.item.approve_subcontractor_payment;
    },
    checkPO() {
      return this.item.purchase_orders;
    },
    checkLabourHourRate() {
      return this.item.labour_hour_rate;
    },
    checkLabourHours() {
      return this.item.labour_hours;
    },
    checkLabourTotalCost() {
      return this.item.labour_total_cost;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {
    checkCurrentUser() {
      if (!this.item.entered_by) {
        this.item.entered_by = this.currentUser.id;
      } else {
        this.item.entered_by = this.item.entered_by;
      }
    },
    checkApproveSubcontractorPayment() {
      if (this.checkApproveSubcontractorPayment) {
        this.showApproveDetails = true;
      } else this.showApproveDetails = false;
    },
    checkPO() {
      if (this.item.purchase_orders.length <= 0) {
        const po_number = {
          created_date: null,
          modified_date: null,
          po_number: "",
          date_po_supplied: null,
          invoice_number: "",
          date_invoiced: null,
          invoiced_by: null,
          invoiced_by__username: null,
        };
        this.purchase_order = po_number;
        this.item.purchase_orders.push(this.purchase_order);
      }
    },
    checkLabourHourRate() {
      this.compute_labour_total_cost();
    },
    checkLabourHours() {
      this.compute_labour_total_cost();
    },
    checkLabourTotalCost() {
      this.compute_labour_total_cost();
    },
  },
  created() {
    this.compute_labour_total_cost();
    this.item.allocated_to = null;
    this.item.accept_supervisor = null;
    this.item.amount = "0.00";
    this.item.labour_total_cost = "0.00";
    this.item.approve_subcontractor_by = null;
    this.item.cancelled_by = null;
    this.item.extra_type = null;
    this.item.po_no_supplied_by = null;
    this.item.purchase_orders = null;
    this.item.raised_by = null;
    this.item.repair_notes = [];
    this.item.terms_and_conditions = null;
    this.item.used_materials = [];
  },
};
</script>

<style scoped>
.avatar {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
</style>
